import React from 'react'
import styled from 'styled-components'
import { theme, colors } from '../../theme/Global'

const NumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 22px;
  font-weight: 600;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  color: ${theme.colors.text};
  background-color: ${(props) => (props.active ? colors.lightBlue : colors.white)};
  font-weight: ${(props) => (props.active ? 'bold' : 'normal')};  
`

class NumberOfDaySelector extends React.Component {
  render() {
    return (
      <React.Fragment>
        <NumberContainer
          active={this.props.active}
          onClick={this.props.onClick}
        >
          {this.props.days}
        </NumberContainer>
      </React.Fragment>
    )
  }
}

export default NumberOfDaySelector
